import { useParams, useNavigate } from "react-router-dom";
import { useState } from "react";
import styles from "./StudentFormBuilder.module.css";

import Summary from "../../sections/Summary/Summary";
import Submission from "../../sections/Submission/Submission";
import IndividualResponses from "../../sections/IndividualResponses/IndividualResponses";

const StudentFormBuilder = () => {
  const { formId } = useParams();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("Summary");

  const tabs = [
    { label: "Summary", content: <Summary formId={formId} /> },
    { label: "Submission", content: <Submission formId={formId} /> },
    {
      label: "Individual responses",
      content: <IndividualResponses formId={formId} />,
    },
  ];

  return (
    <div className={styles.StudentFormBuilder}>
      <div className={styles.headerRow}>
        <div className={styles.backBtn} onClick={() => navigate(-1)}>
          ← Student application form Builder
        </div>
        <div className={styles.toggleSwitch}>
          <label>Disable responses</label>
          <label className={styles.switch}>
            <input type="checkbox" />
            <span className={styles.slider}></span>
          </label>
        </div>
      </div>

      <div className={styles.tabRow}>
        {tabs.map((tab, idx) => (
          <div
            key={idx}
            className={`${styles.tabOption} ${
              activeTab === tab.label ? styles.activeTab : ""
            }`}
            onClick={() => setActiveTab(tab.label)}
          >
            {tab.label}
          </div>
        ))}
      </div>

      <div className={styles.tabContent}>
        {tabs.find((tab) => tab.label === activeTab)?.content}
      </div>
    </div>
  );
};

export default StudentFormBuilder;
